import React, { useState } from 'react';
import { HiChevronDown } from 'react-icons/hi';

interface SectionCardProps {
    title: string;
    description?: string;
    icon?: React.ReactNode;
    actions?: React.ReactNode;
    collapsible?: boolean;
    defaultOpen?: boolean;
    tone?: 'default' | 'muted';
    children: React.ReactNode;
}

const SectionCard: React.FC<SectionCardProps> = ({
    title,
    description,
    icon,
    actions,
    collapsible = false,
    defaultOpen = true,
    tone = 'default',
    children,
}) => {
    const [open, setOpen] = useState(defaultOpen);
    const surface =
        tone === 'muted'
            ? 'bg-slate-50 dark:bg-slate-800/60'
            : 'bg-white dark:bg-slate-800';
    return (
        <section className={`rounded-xl border border-gray-200 dark:border-slate-700 ${surface}`}>
            <header
                className={`flex items-start gap-3 px-5 py-4 ${collapsible ? 'cursor-pointer select-none' : ''}`}
                onClick={collapsible ? () => setOpen((o) => !o) : undefined}
            >
                {icon && <span className="mt-0.5 text-gray-500 dark:text-gray-400">{icon}</span>}
                <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-100">{title}</h3>
                    {description && <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{description}</p>}
                </div>
                {actions && <div onClick={(e) => e.stopPropagation()}>{actions}</div>}
                {collapsible && (
                    <HiChevronDown className={`text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} size={18} />
                )}
            </header>
            {open && <div className="px-5 pb-5">{children}</div>}
        </section>
    );
};

export default SectionCard;
